import React from "react";

// Link text that says nothing on its own (screen-reader users often browse a list
// of links, and search engines read the text as the link's description).
const GENERIC_LABELS = new Set([
  "click here",
  "details",
  "here",
  "learn more",
  "more",
  "read more",
  "see more",
  "view more",
]);

/**
 * Renders link text. If the (CMS-editable) text is a generic phrase such as
 * "Learn More", a visually hidden suffix gives it context ("Learn More about
 * Shamshersons") while the visible label stays exactly as written.
 */
const LinkLabel = ({ children, about }) => {
  const text = typeof children === "string" ? children.trim().toLowerCase() : "";
  const needsContext = Boolean(about) && GENERIC_LABELS.has(text);

  return (
    <>
      {children}
      {needsContext && <span className="visually-hidden"> about {about}</span>}
    </>
  );
};

export default LinkLabel;
